import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './WeChatBrowserTip.css';

/**
 * 微信浏览器检测提示组件
 * 检测到在微信内置浏览器中时，自动重定向到中间页面
 * 临时测试：在 URL 中添加 ?test_wechat=1 可以强制显示提示
 */
const WeChatBrowserTip = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 检测是否在微信内置浏览器中
    const isWeChat = /micromessenger/i.test(navigator.userAgent);

    // 临时测试：URL 参数 test_wechat=1 强制显示提示
    const urlParams = new URLSearchParams(location.search);
    const forceShow = urlParams.get('test_wechat') === '1';

    // 如果在微信浏览器中，且不在重定向页面，且不是测试模式
    if (isWeChat && location.pathname !== '/redirect' && !forceShow) {
      // 保存当前路径，以便在浏览器中打开后跳转回去
      sessionStorage.setItem('wechatRedirectPath', location.pathname + location.search);
      navigate('/redirect');
    }
  }, [navigate, location]);

  return null;
};

export default WeChatBrowserTip;
